import Action from './modules/Action';
import FromValidation from './modules/FromValidation';

import './legacy/main.js';
import './legacy/activica.js';
import './legacy/app.js';
import './modules/dropdown';

$(() => new FromValidation().render());

// jQuery
(function ($) {
  $(function () {

    let $body = $('body');

    // Запустить слайдеры
    slickInit();

    // Клик
    $body.on('click', '[data-click]', function () {
      let data = $(this).data('click');

      new Action(data, this);
      if ($(this).is('a')) return false;
    });

    if ($(window).width() < 505) {
      $body.on('click', '[data-click-mob]', function () {
        let data = $(this).data('click-mob');

        new Action(data, this);
        if ($(this).is('a')) return false;
      });
    }

    $('.js-slider').each((index, element) => {
      const $slider = $(element);
      const data = $slider.data('slider');

      $slider.addClass('js-slider--init').slick(data);
    });
  });
})(jQuery);

function slickInit() {
  $('[data-slick]:visible:not(.active)').each(function (index, element) {
    let $this = $(element),
      data = $this.data('slick');

    $this.addClass('active').slick(data);
  });

  const $mainEventSlider = $('.js--main-events-slider');

  $mainEventSlider.addClass('js--init').slick({
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    adaptiveHeight: true,
  });

  $mainEventSlider.on('afterChange', (slick, currentSlide) => {
    $('.js--main-events-item[data-number=' + currentSlide.currentSlide + ']').addClass('--active').siblings().removeClass('--active');
    $('.js--main-events-slider-current-slid').text(currentSlide.currentSlide + 1);
  });

  $('.js--main-events-item').on('click', function () {
    $mainEventSlider.slick('slickGoTo', parseInt($(this).data('number')));
  });
}

$('.js-jqselect').JQSelect({
  hideFilter: true,
  hideSelectAll: true,
});
